module.exports = __webpack_public_path__ + "static/media/Onest-Bold.6087f778.woff2";